module.exports = __webpack_public_path__ + "static/assets/5aa5b485f3fa63f79d00103cba3bd7de.png";